import { ArrowRight, Building2, Mail, ShieldCheck } from 'lucide-react'

const SUPPORT_EMAIL = 'jonathanayabulela35@gmail.com'

export function Contact() {
  return <>
    <section className="public-page-hero public-container contact-hero">
      <span className="public-kicker">Contact Mail Percent</span>
      <h1>Tell us what you need help with.</h1>
      <p>
        Get help with your Mail Percent workspace, Google Workspace or Microsoft 365 integration, connected mailboxes or a privacy and data request.
      </p>
    </section>

    <section className="public-section public-container contact-section">
      <div className="contact-layout">
        <article className="contact-primary-card">
          <span className="contact-icon"><Mail size={22}/></span>
          <span className="public-kicker">Email support</span>
          <h2>Contact the Mail Percent team directly.</h2>
          <p>
            Send us the details of what you are trying to do, what happened and any relevant workspace or browser information. We will reply by email.
          </p>

          <a
            className="button primary public-cta contact-email-button"
            href={`mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent('Mail Percent support')}`}
          >
            Email Mail Percent <ArrowRight size={16}/>
          </a>

          <a className="contact-email-address" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
        </article>

        <div className="contact-support-grid">
          <article>
            <span className="contact-support-icon"><Mail/></span>
            <div>
              <span>Workspace support</span>
              <h3>Accounts, teams and connected mailboxes</h3>
              <p>Use this for sign-in, onboarding, organisation setup, integrations, reports or workspace behaviour.</p>
            </div>
          </article>

          <article>
            <span className="contact-support-icon"><Building2/></span>
            <div>
              <span>Organisation integration support</span>
              <h3>Google Workspace and Microsoft 365 setup</h3>
              <p>Use this for domain connection, admin consent, directory sync or measured-user selection issues.</p>
            </div>
          </article>

          <article>
            <span className="contact-support-icon"><ShieldCheck/></span>
            <div>
              <span>Privacy & data requests</span>
              <h3>Questions about data access or removal</h3>
              <p>Contact us about privacy, connected account data, access requests or deletion requests.</p>
            </div>
          </article>
        </div>
      </div>
    </section>

    <section className="public-section public-soft-section">
      <div className="public-container contact-guidance">
        <div>
          <span className="public-kicker">Help us investigate quickly</span>
          <h2>Include the useful details, not sensitive credentials.</h2>
        </div>

        <div className="contact-guidance-list">
          <div><b>01</b><span>Tell us which Mail Percent page or feature you were using.</span></div>
          <div><b>02</b><span>Describe what you expected and what actually happened.</span></div>
          <div><b>03</b><span>For integration issues, include the provider, the step you reached and any error message shown.</span></div>
          <div><b>04</b><span>Never send passwords, OAuth tokens, API keys or confidential email content.</span></div>
        </div>
      </div>
    </section>
  </>
}
